export const Railcards = [
  {
    code: "2TR",
    name: "Two Together Railcard"
  },
  {
    code: "DIC",
    name: "Disabled Child Railcard"
  },
  {
    code: "DIS",
    name: "Disabled Persons Railcard"
  },
  {
    code: "FAM",
    name: "Family & Friends Railcard"
  },
  {
    code: "HMF",
    name: "HM Forces Railcard"
  },
  {
    code: "JCP",
    name: "Jobcentre Plus Travel Discount Card"
  },
  {
    code: "NEW",
    name: "Network Railcard"
  },
  {
    code: "NGC",
    name: "Annual Gold Card"
  },
  {
    code: "SRN",
    name: "Senior Railcard"
  },
  {
    code: "TST",
    name: "26-30 Railcard"
  },
  {
    code: "TSU",
    name: "16-17 Saver"
  },
  {
    code: "VET",
    name: "Veterans Railcard"
  },
  {
    code: "YNG",
    name: "16-25 Railcard"
  }
];

export const TPERailcards = [
  { name: "16-17 Saver", code: "TSU" },
  { name: "16-25 Railcard", code: "YNG" },
  { name: "26-30 Railcard", code: "TST" },
  { name: "Annual Gold Card / Gold Record Card", code: "NGC" },
  { name: "Disabled Persons Railcard", code: "DIS" },
  { name: "Disabled Child Railcard", code: "DIC" },
  { name: "Family & Friends Railcard", code: "FAM" },
  { name: "Job Centre Plus Travel Discount", code: "JCP" },
  { name: "Job Seekers TPE Discount", code: "JSD" },
  { name: "MyCumbria Card", code: "CUR" },
  { name: "North Lincolnshire Concessionary 34%", code: "HCC" },
  { name: "North Lincolnshire Concessionary 50%", code: "HCS" },
  { name: "NE Lincs Concession 34", code: "L34" },
  { name: "NE Lincs Concession 50", code: "L50" },
  { name: "Network Railcard", code: "NEW" },
  { name: "Nexus Employee", code: "NEX" },
  { name: "HM Forces Railcard", code: "HMF" },
  { name: "Senior Railcard", code: "SRN" },
  { name: "TOTUM NUS Extra", code: "NUS" },
  { name: "Two together Railcard", code: "2TR" },
  { name: "Veteran Railcard", code: "VET" },
  { name: "West Yorkshire Disabled Concessionary Discount", code: "WYD" },
  { name: "West Yorkshire Senior Concessionary Discount", code: "WYS" },
  { name: "WY Under 19 PhotoCard", code: "WMS" }
];
